module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../../node_modules/happypack/loader.js?id=jsx!./CheckPictureView.js"));
	}, "CheckPictureView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=CheckPictureView!./src/pages/Promote/OfflineActivity/ActivityPicture/CheckPicture/CheckPictureView.js
// module id = 1692
// module chunks = 418